import React from 'react';
import { motion } from 'framer-motion';
import { TeamSectionProps } from '@/types/components';
import Bobbie from '../../images/team-bobbie.webp';
import Soven from '../../images/team-soven.webp';
import Kamal from '../../images/team-kamal.webp';

const TEAM_MEMBERS = [
  {
    name: "Bobbie Shrivastav",
    role: "Co-Founder & CEO",
    description: "2nd InsurTech Venture, 20+ years in Financial Services",
    image: Bobbie
  },
  {
    name: "Soven Shrivastav",
    role: "Co-Founder & CTO",
    description: "20+ years in IT and Innovation, 7 Insurance/Healthcare Startups",
    image: Soven
  },
  {
    name: "Kamal Bansal",
    role: "Chief Product Officer",
    description: "Former Northwestern Mutual Executive, 25+ years in Insurance and Tech Ops",
    image: Kamal
  }
];

const TeamSection: React.FC<TeamSectionProps> = ({ className = '' }) => {
  return (
    <section id="team" className={`py-20 bg-gradient-to-b from-gray-900 to-blue-900 ${className}`}>
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent">
            Meet Our Team
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Industry veterans with decades of experience in Insurance, Technology, and Innovation
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {TEAM_MEMBERS.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="text-center group"
            >
              <div className="relative w-56 h-56 mx-auto mb-6">
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-emerald-500/30 rounded-full blur-2xl 
                  group-hover:from-blue-500/40 group-hover:to-emerald-500/40 transition-all duration-300" />
                
                {/* Image Container */}
                <div className="relative w-full h-full rounded-full overflow-hidden border-2 border-gray-700/50
                  group-hover:border-blue-500/50 transition-all duration-300">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-center transform 
                      group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
              </div>

              <motion.h3 
                className="text-xl font-bold mb-2 bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent"
              >
                {member.name}
              </motion.h3>
              <motion.p 
                className="text-gray-300 font-medium mb-2"
              >
                {member.role}
              </motion.p>
              <motion.p 
                className="text-gray-400 text-sm max-w-xs mx-auto"
              >
                {member.description}
              </motion.p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
